function getKioskWebBaseUrl(): string {
  const raw = import.meta.env.VITE_KIOSK_WEB_BASE_URL?.trim();
  return raw ? raw.replace(/\/$/, "") : "http://localhost:8081";
}

/** Kiosk web preview URL with the portal JWT so detail APIs can authorize. */
export function buildKioskActivityPreviewUrl(
  activityId: string,
  accessToken?: string | null,
): string {
  const params = new URLSearchParams({ preview: "1" });
  const token = accessToken?.trim();
  if (token) {
    params.set("preview_token", token);
  }
  return `${getKioskWebBaseUrl()}/activity/${activityId}?${params.toString()}`;
}
